// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".deleteButton_xz8xeTI8:not([disabled]){color:rgba(var(--color-body-color), 0.8)}.deleteButton_xz8xeTI8:not([disabled]):hover{color:var(--color-red-500)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"deleteButton": "deleteButton_xz8xeTI8"
};
export default ___CSS_LOADER_EXPORT___;
